export default "__VITE_ASSET__DWlGdLWT__"